<ng-container *transloco="let t;">

  <div class="loader-while" *ngIf="!detailsParsed">
    <fa-icon [icon]="['fas', 'circle-notch']" class="fa-spin"></fa-icon>
  </div>
  <div class="items-section" *ngIf="detailsParsed">
    <div class="items-side">
      <div class="other-card" *ngFor="let pi of parsedItems | assetFilter: filterSearch" (click)="openDetails(pi)">
        <div class="item-balance">{{pi.balance}}</div>
        <div class="other-card-img" [ngClass]="{'full-image':pi.metadata.properties.category=='armor'}">
          <div class="cr cr-top cr-right cr-purple-gradient" *ngIf="pi.order">{{t('shared.onSale')}}</div>
          <img src="{{pi.metadata.image}}" />
        </div>
        <div class="other-card-content">
          <div class="name-row">
            <!-- <span>{{pi.metadata.nameFormatted}}</span> -->
            <span>{{t(pi.metadata.name+'.name'|replace:'powerup-':'' )}}</span>
            <span>{{t('shared.type')}}: {{pi.metadata.typeFormatted}}</span>
            <!--<span>Description: {{pi.metadata.descriptionFormatted}}</span>-->
            <!--<span *ngIf="pi.data.order" class="price-span">${{pi.data.order.priceUSD.toLocaleString()}}</span>-->
          </div>
          <div class="nft-crafting-progress" *ngIf="pi.craftingPercentage">
            <div class="nft-crafting-level-icon" *ngFor="let cr of craftingLevels">
              <img src="./assets/img/nftItems/tiers/level-{{cr.level}}.png"
                [ngClass]="{'unselected': cr.level!=pi.craftingStage}" />
            </div>
            <!--<span>[{{pi.craftingStage}}/{{pi.craftingMax}}]</span>
            <div class="progress-bar">
              <span class="progress-bar-fill" style="width: {{pi.craftingPercentage}}%;"></span>
            </div>-->
          </div>
          <div class="nft-icon" *ngIf="pi.kind=='nft'">
            <img src="./assets/img/Icon/nft-icon.svg" *ngIf='!pi.metadata.properties.bound' />
            <img src="./assets/img/Icon/nft-bound.png" *ngIf='pi.metadata.properties.bound' />
          </div>
        </div>
      </div>
      <div class="no-kryptomon-container" *ngIf="parsedItems.length==0">
        <div class="chat-container">
          <div class="chat-box">
            <img src="./assets/img/portal-op.png" />
            <div class="chat-box-text">
              <h1 class="title-gradient gradient-pp">{{t('shared.hey')}}</h1>
              <p>{{t('assets.inventoryEmpty')}}
              <p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="items-filter">
      <div class="filter-card" [ngClass]="{'open':openFilter}">
        <div class="filter-card-title">
          <h3>{{t('assets.filterCategory')}}</h3>
          <div class="filter-icon" (click)="openFilter=!openFilter">
            <img src="./assets/img/Icon/filter.png" *ngIf="!openFilter" />
            <img src="./assets/img/Icon/Close.png" *ngIf="openFilter" />
          </div>
        </div>
        <div class="remove-filters" (click)="removeFilter()">
          <div class="remove-icon">
            <fa-icon [icon]="['fas', 'times']"></fa-icon>
          </div>{{t('shared.showAll')}}
        </div>
        <div class="filter-section" *ngFor="let filterCat of filters; let x = index">
          <span>{{filterCat.title}}</span>
          <div class="filter-item-container">
            <div class="filter-item" *ngFor="let filterItem of filterCat.filterItems; let i = index"
              (click)="selectFilter(x,i)" [ngClass]="{'selected':filterItem.selected}">
              <div class="img-background">
                <img src="{{filterItem.img}}" *ngIf="filterItem.img" />
              </div>
              <span>{{filterItem.value}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>